/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'
import BookIcon from '@mui/icons-material/Book'
import {
  Alert,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

import { useDataProvider } from 'react-admin'
import _ from 'lodash'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied'
import moment from 'moment'
import { Link } from 'react-router-dom'
import 'moment/locale/fr'
import SelectVideoman from '../Components/SelectVideoman'
// import { useMutation } from 'react-query'
// import videosProvider from '../DataProvider/videosProvider'

moment.locale('fr')

export const HomeIcon = BookIcon

export const Home = () => {
  const dataProvider = useDataProvider()
  const [videoWithout_vue, setvideoWithout_vue] = useState([])
  const [videoWithout_link_video, setvideoWithout_link_video] = useState([])
  const [loading, setLoading] = useState(false)

  const dataToFetch = ['video_vue_par', 'link_video']
  const fetchDataWitherror = async (type) => {
    try {
      const res = await dataProvider.getList('video-tandem', {
        pagination: { page: 1, perPage: 99 },
        sort: { field: 'id', order: 'DESC' },
        filter: { post_metas: { [type]: 'false' } }
      })
      return res.data
    } catch (error) {
      console.log(error)
      return []
    }
  }
  useEffect(() => {
    const updateData = {
      video_vue_par: setvideoWithout_vue,
      link_video: setvideoWithout_link_video
    }
    dataToFetch.forEach(async (x) => {
      const newData = await fetchDataWitherror(x)
      updateData[x](newData)
    })
  }, [])

  const resultFinal = _.unionBy(videoWithout_link_video, videoWithout_vue, 'id')

  const handleVideoman = async (row, videoman) => {
    console.log(row, videoman)
    setLoading(row.id)
    const res = await dataProvider.update('video-tandem', {
      data: { ...row, post_metas: { ...row.post_metas, videoman } }
    })

    const _videoWithout_vue = videoWithout_vue.map((x) =>
      x.id === res?.data?.id ? res?.data : x
    )
    const _videoWithout_link_video = videoWithout_link_video.map((x) =>
      x.id === res?.data?.id ? res?.data : x
    )
    setvideoWithout_vue(_videoWithout_vue)
    setvideoWithout_link_video(_videoWithout_link_video)
    setLoading(false)
  }

  return (
    <div>
      <Grid container spacing={3} marginBottom={5}>
        <Grid item sm={4}>
          <Alert severity='error'>
            Il y a {videoWithout_link_video.length} vidéo(s) manquante(s)
          </Alert>
        </Grid>
        <Grid item sm={4}>
          <Alert severity='error'>
            Il y a {videoWithout_vue.length} vidéo(s) non ouverte(s)
          </Alert>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>Nom</TableCell>
              <TableCell align='center'>Date</TableCell>
              <TableCell align='center'>Videoman</TableCell>
              <TableCell align='center'>Video</TableCell>
              <TableCell align='center'>Page ouverte</TableCell>
              <TableCell align='center' />
            </TableRow>
          </TableHead>
          <TableBody>
            {resultFinal.map((row) => (
              <TableRow key={row.id}>
                <TableCell component='th' scope='row'>
                  {row?.post_metas?.nom} {row?.post_metas?.prenom}
                </TableCell>
                <TableCell component='th' scope='row' align='center'>
                  {moment(row?.date).format('DD MMMM YYYY')}
                </TableCell>
                
                <TableCell align='center'>
                  {window?.variables?.user?.user_roles?.includes(
                    'administrator'
                  ) && (
                    <SelectVideoman
                      loading={loading === row.id}
                      handleVideoman={handleVideoman}
                      data={row}
                    />
                  )}
                  {(!window?.variables?.user?.user_roles?.includes(
                    'administrator'
                  ) && !+row?.post_metas?.videoman) && (
                    <button
                      type='button'
                      onClick={() =>
                        handleVideoman(row, window?.variables?.user?.user_id)
                      }>
                      M&apos;ajouter la vidéo
                      {loading === row.id && (
                        <CircularProgress
                          style={{
                            width: '15px',
                            height: '15px',
                            marginLeft: '5px',
                            color: '#fff'
                          }}
                        />
                      )}
                    </button>
                  )}
                  {(!window?.variables?.user?.user_roles?.includes(
                    'administrator'
                  ) && !!+row?.post_metas?.videoman)&& (
                    window?.variables?.users?.find(
                      (x) => +x.userId === +row?.post_metas?.videoman
                    )?.fullName || 'videoman introuvable'
                  )}
                </TableCell>
                <TableCell align='center'>
                  {row?.post_metas?.link_video ? (
                    <ThumbUpIcon style={{ color: 'green' }} />
                  ) : (
                    <SentimentDissatisfiedIcon style={{ color: 'red' }} />
                  )}
                </TableCell>
                <TableCell align='center'>
                  {row?.post_metas?.date_vue ? (
                    <ThumbUpIcon />
                  ) : (
                    <SentimentDissatisfiedIcon />
                  )}
                </TableCell>
                <TableCell align='center'>
                  <Link to={`/video-tandem/${row.id}`}>Edit</Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
